<div *ngIf="currentPatient && isAccountUser !== null"
     class="patient-bar d-flex align-items-center {{styleClass}}"
     [class.patient-bar_authorized-for]="!isAccountUser">
  <i class="icosun-user_circle patient-bar_icon mr-2"></i>
  <span class="patient-bar_info-name">
    <ng-container *ngIf="!isAccountUser">
      <span [innerHTML]="'SI_AS_OF' | translate:
        {name: (currentPatientAuthorization?.role?.code === patientRoles.LEGAL_REPRESENTATIVE ? ('SI_LEGAL_REPRESENTATIVES_SHORT' | translate) : currentPatientAuthorization?.role.name)}"
      ></span>
      <span class="patient-bar_line mx-2"></span>
    </ng-container>
    <span class="bold mr-5">
      {{currentPatient.personalData?.firstName}}
      {{currentPatient.personalData?.surname1}}
      {{currentPatient.personalData?.surname2}}
    </span>
  </span>
  <span class="patient-bar_info-birthdate bold mr-5 d-none d-lg-block text-lowercase">
    {{currentPatient.personalData?.birthDate | amDateFormat: 'L'}} ({{currentPatient.personalData?.birthDate | getAge}})
  </span>
  <span class="mr-5 bold d-none d-lg-block">{{currentPatient.personalData?.gender?.name}}</span>
  <ng-container *siSecure="['my_circle:get_authorized_by']">
    <a *ngIf="patientCircle?.length"
       class="si-button_icon-white ml-auto mr-2"
       [routerLink]="['/role-change']">
      <i class="icosun-arrow_swap patient-bar_icon"
         pTooltip="{{'SI_ACCESS_AS' | translate}}"
         tooltipPosition="left"
      ></i>
    </a>
  </ng-container>
</div>
